import React from 'react';

import PropTypes from 'prop-types';

export const ContextProvider = Component => {
  const Wrapper = (props, context) => {
    const menu = context.providers.restaurant.getMenu();
    const offlineMenus = context.providers.restaurant.getOfflineMenus();
    const restaurant = context.providers.restaurant.getMeta();
    return (
      <Component
        restaurant={restaurant}
        menu={menu}
        offlineMenus={offlineMenus}
        {...props}
      />
    );
  };

  Wrapper.contextTypes = {
    providers: PropTypes.object
  };
  return Wrapper;
};



// WEBPACK FOOTER //
// ./components/ContextProvider/ContextProvider.js